// Home.jsx
import React from 'react';
import './App.css';
import './Login.css';
import './Home.css';
import HomePage from './components/HomePage';

const Home = () => {
  return (
    <div className="App">
      <HomePage />
      <div className="homepage">
        <img 
          src={`${process.env.PUBLIC_URL}/imag2.jpg`} 
          alt="Homepage Visual" 
          className="responsive-imag" 
          draggable="false" // Prevent dragging
          onDragStart={(e) => e.preventDefault()} // Block drag start event
        />
      </div>
    </div>
  );
};

export default Home;